export const COMPLIANCE_INDEX_LIST_CHANGESETS = 'COMPLIANCE_INDEX_LIST_CHANGESETS';
export const COMPLIANCE_INDEX_LIST_CHANGESETS_SUCCESS = 'COMPLIANCE_INDEX_LIST_CHANGESETS_SUCCESS';
export const COMPLIANCE_INDEX_LIST_CHANGESETS_FAIL = 'COMPLIANCE_INDEX_LIST_CHANGESETS_FAIL';

export const COMPLIANCE_INDEX_CREATE_CHANGESET = 'COMPLIANCE_INDEX_CREATE_CHANGESET';
export const COMPLIANCE_INDEX_CREATE_CHANGESET_SUCCESS = 'COMPLIANCE_INDEX_CREATE_CHANGESET_SUCCESS';
export const COMPLIANCE_INDEX_CREATE_CHANGESET_FAIL = 'COMPLIANCE_INDEX_CREATE_CHANGESET_FAIL';

export const COMPLIANCE_INDEX_LIST_CHANGESETS_CLEAR = 'COMPLIANCE_INDEX_LIST_CHANGESETS_CLEAR';
